import React from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import BrandPartnershipComponent from "../../Components/BrandPartnershipComponent/BrandPartnershipComponent";

const BrandPartnership = () => {
  return (
    <div>
      <Header />
      <BrandPartnershipComponent />
      <Footer />
    </div>
  );
};

export default BrandPartnership;